// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/js/chunk" + chunkId + "." + {"47":"fc842ae794f2b7e4","88":"fcde80c31b5811ab"}[chunkId] + ".js";
};